import { BUDGET_TIER_LABEL, formatPriceRangeMillion } from "features/ProjectType/core";
import { ANSWER_TYPE, BUDGET_TYPE, TIMELINE_LABEL } from "features/ConsultRequest/core/constants";
import { formatDate, formatNumber } from "features/ConsultRequest/core/utils";

const csv = (arr) => (arr?.length ? arr.join(",") : undefined);

// Filter UI -> query PW1/PW2 (mảng gửi CSV, bỏ giá trị rỗng).
export function mapListFilters(filters = {}) {
  const q = {
    projectTypeIds: csv(filters.projectTypeIds),
    budgetFilter: csv(filters.budgetFilter),
    timelines: csv(filters.timelines),
    createdFrom: filters.createdFrom || undefined,
    createdTo: filters.createdTo || undefined,
    assigneeId: filters.assigneeId || undefined,
    possibleDuplicate: filters.possibleDuplicate ? true : undefined,
    keyword: filters.keyword?.trim() || undefined,
  };
  return Object.fromEntries(Object.entries(q).filter(([, v]) => v !== undefined));
}

export function mapBudget({ budgetType, budgetTier, budgetAmount }) {
  if (budgetType === BUDGET_TYPE.CUSTOM) return formatNumber(budgetAmount);
  return BUDGET_TIER_LABEL[budgetTier] || "";
}

export function mapTimeline({ timeline, scheduledDate }) {
  const label = TIMELINE_LABEL[timeline] || "";
  return scheduledDate ? `${label} (${formatDate(scheduledDate)})` : label;
}

export const mapDealer = (dealer) => ({
  taxCode: dealer?.taxCode || null,
  companyName: dealer?.companyName || "",
});

export function mapAnswer({ label, unit, answerType, value }) {
  let text;
  if (answerType === ANSWER_TYPE.YES_NO) text = value ? "Có" : "Không";
  else if (answerType === ANSWER_TYPE.MULTI_CHOICE) text = (value || []).join(", ");
  else if (answerType === ANSWER_TYPE.NUMBER) text = unit ? `${value} ${unit}` : `${value}`;
  else text = value == null ? "" : String(value);
  return { label, text };
}

export const mapSnapshotPrice = (s) =>
  formatPriceRangeMillion(s?.priceFromMillion, s?.priceToMillion, { withCurrency: true });
